import styled from 'styled-components';

export const Container = styled.div`
    display: flex;
    z-index: 100;
    height: 100%;
    position: relative;
}
`;

export const CollapseButton = styled.div`
    margin: 10px;
    position: absolute;
    right: -70px;
}
`;
